goog.provide('el8.appchart.mainFeeds.reqActReactRenderMap');

el8.appchart.mainFeeds.reqActReactRenderMap = {
  PatientFormRequest: function(params) {
    el8React.render.requiringActionsFormRequestItem(params.containerId, {
      feedIndexItem: params.indexedItem,
      patientFormRequestId: params.itemId
    });
  },
  VisitNote2: function(params) {
    el8React.render.requiringActionsNote2Item(params.containerId, {
      feedIndexItem: params.indexedItem,
      noteId: params.itemId
    });
  }
}
